<script setup lang="ts">
import type { Component } from 'vue'

withDefaults(defineProps<{
    as: string | Component,
    active: boolean,
}>(), {
    active: false,
})
</script>

<template>
    <component :is="as" :class="['flex items-center px-2 py-1.5 text-p2 rounded outline-none hover:bg-mint-50', active ? 'font-medium text-grayscale-900 hover:text-mint-900' : 'font-normal text-grayscale-700 hover:text-mint-800']" role="menuitem" tabindex="-1">
        <slot />
    </component>
</template>
